import { PropsWithChildren } from 'react'

import { LexicalComposer } from '@lexical/react/LexicalComposer'

import { RichEditorStoreProvider } from '../../Store'

import { RichEditorContextProviderProps } from './interface'

export const RichEditorContextProvider = ({
  lexicalConfig,
  storeConfig,
  children
}: PropsWithChildren<RichEditorContextProviderProps>) => {
  return (
    <RichEditorStoreProvider {...storeConfig}>
      <LexicalComposer initialConfig={lexicalConfig}>
        {children}
      </LexicalComposer>
    </RichEditorStoreProvider>
  )
}
